import { Link } from "react-router-dom";

import styles from "./styles.module.css";

interface TimelineItemProps {
  date: string;
  tag?: string;
  title: string;
  summary: string;
  to?: string;
}

export function TimelineItem({ date, tag, title, summary, to }: TimelineItemProps) {
  const body = (
    <>
      <div className={styles.meta}>
        <time className={styles.date}>{date}</time>
        {tag ? <span className={styles.tag}>{tag}</span> : null}
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.summary}>{summary}</p>
    </>
  );

  return (
    <article className={styles.item} data-reveal>
      <span className={styles.dot} aria-hidden="true" />
      {to ? (
        <Link to={to} className={styles.content}>
          {body}
        </Link>
      ) : (
        <div className={styles.content}>{body}</div>
      )}
    </article>
  );
}

export default TimelineItem;
